// Component: Skeleton.jsx
// Purpose: DS skeleton placeholder — a shimmering block that mimics content
//          shape while it loads. Use for content / route / table / card /
//          section loading; it reads faster than a spinner and keeps the
//          animated Loader mark rare. Compose several to sketch a card / row /
//          page shell.
//
// Usage:
//   <Skeleton w="60%" h={12} />          // text line
//   <Skeleton circle w={40} h={40} />    // avatar
//   <Skeleton h={48} />                  // full-width block

import React from "react";
import { cx } from "./cx";

const px = (v) => (typeof v === "number" ? `${v}px` : v);

export const Skeleton = ({ w, h = 12, radius, circle = false, className, style, ...props }) => (
  <span
    className={cx("ds-skeleton", className)}
    aria-hidden="true"
    style={{
      width: w != null ? px(w) : "100%",
      height: px(h),
      borderRadius: circle ? "9999px" : (radius != null ? px(radius) : undefined),
      ...style,
    }}
    {...props}
  />
);

export default Skeleton;
